import posthog from 'posthog-js';
import { UserInfo } from '@/types/users';

if (typeof window !== 'undefined') {
  // Initialize PostHog only on the client side
  posthog.init(import.meta.env.VITE_POSTHOG_KEY || '', {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
    person_profiles: 'identified_only',
    opt_in_site_apps: true,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true
      }
    }
  });
}

const eventQueue: Array<{ eventName: string; properties?: Record<string, any> }> = [];

export const captureEvent = (eventName: string, properties?: Record<string, any>) => {
  if (typeof window == 'undefined') {
    console.warn('PostHog is not available on the server.');
    return;
  }

  if (!posthog.__loaded) {
    console.warn('PostHog not ready, queuing event:', eventName);
    eventQueue.push({ eventName, properties });
    return;
  }

  while (eventQueue.length) {
    const { eventName, properties } = eventQueue.shift()!;
    posthog.capture(eventName, properties);
  }

  posthog.capture(eventName, properties);
};

export function identifyUser(user: UserInfo) {
  if (typeof window == 'undefined' || !posthog.__loaded) {
    console.warn('PostHog is not available on the server.');
    return;
  }

  posthog.identify(user.id, {
    role: user.role,
    email: user.email,
    firstName: user.firstName ?? '',
    lastName: user.lastName ?? '',
    name: `${user.firstName} ${user.lastName}`,
    isEmployee: user.email.endsWith('@practivated.com'),
    organizationId: user.organizationId,
    organizationName: user.organizationName
  });
}
